import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import {
  Card,
  Row,
  Col,
  Badge,
  Spinner,
  Alert,
  Container,
  Button,
  Form,
  Table, Collapse,
  Accordion
} from 'react-bootstrap';
import {
  FaMoneyBillWave,
  FaCalendarAlt,
  FaSchool,
  FaReceipt,
  FaCreditCard,
  FaCheck,
  FaTimesCircle,
  FaSync,
  FaArrowLeft,
  FaDownload,
  FaUserGraduate,
  FaCalendarDay,
  FaExclamationTriangle,
  FaEye,
  FaEyeSlash, FaChevronUp, FaChevronDown
} from 'react-icons/fa';
import Header from './Header';
import { ProductContext } from '../context/AppContext';
import Swal from 'sweetalert2';
import moment from 'moment';
import { KJUR } from "jsrsasign";
import { useNavigate } from 'react-router-dom';

const FeeCollection = () => {
  const [loading, setLoading] = useState(true);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [feesData, setFeesData] = useState(null);
  const [error, setError] = useState(null);
  const [availableInstallments, setAvailableInstallments] = useState([]);
  const [feeCycleData, setFeeCycleData] = useState(null);
  const [allInstallmentsData, setAllInstallmentsData] = useState({});
  const [selectedInstallments, setSelectedInstallments] = useState([]);
  const [loadingInstallments, setLoadingInstallments] = useState({});
  const [studentDetails, setStudentDetails] = useState(null);
  const [paying, setPaying] = useState(false);
  const [showPaymentSection, setShowPaymentSection] = useState(false);
  const navigate = useNavigate();
  const [showStudent, setShowStudent] = useState(true);
  const [showInstallments, setShowInstallments] = useState(true);
  const [showPaid, setShowPaid] = useState(true);
  const [showInstallmentDetails, setShowInstallmentDetails] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const toggleExpand = (key) => {
    setExpandedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const discountApprovalCache = useRef(new Map());
  const [schoolDetails, setSchoolDetails] = useState({});
  const feeDataCacheRef = useRef({
    key: null,
    data: null,
    monthlyMap: null,
    promise: null,
  });

  const {
    getRegistration,
    allClass = [],
    session = [],
    StudentProfileData,
    userData,
    GetstudentData,
    ClassSection,
        classSections22
  } = useContext(ProductContext);

  const StudentgetId = GetstudentData?.id;

  const ClasSectionId = GetstudentData?.class_section_id;

  console.log(ClassSection, "ClassSection Data");
  console.log(classSections22, "ClassSection Data 2");

  const classSectionMap = React.useMemo(() => {
        const map = {};
        (classSections22?.data || []).forEach(item => {
            map[item.id] = `${item.class_name} - ${item.section_name}`;
        });
        return map;
    }, [classSections22]);

  const feeCycleId = localStorage.getItem('fee_cycle_id');
  const authtoken = localStorage.getItem('token');
  const regsId = getRegistration?.data?.id || userData?.userId;
  const schema = userData?.currentUser?.schema;
  const studentId = studentDetails?.id || StudentProfileData?.id || getRegistration?.data?.student_id;
  const [openMonth, setOpenMonth] = useState(null);
  const activeSessionId =
    Number(StudentProfileData?.session) ||
    Number(studentDetails?.session) ||
    Number(studentDetails?.session_id) ||
    null;

  const fetchStudentDetails = async () => {
    if (!regsId || !authtoken) return;
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/student?regs_id=${regsId}`,
        {
          headers: { 'x-auth': authtoken },
        }
      );
      const data = await response.json();
      if (data.success && data.message.length > 0) {
        setStudentDetails(data.message[0]);
      }
    } catch (err) {
      console.error('Error fetching student details:', err);
    }
  };

  useEffect(() => {
    fetchStudentDetails();
  }, [regsId, authtoken]);

  useEffect(() => {
    discountApprovalCache.current = new Map();
  }, [studentId, activeSessionId]);

  useEffect(() => {
    feeDataCacheRef.current = {
      key: null,
      data: null,
      monthlyMap: null,
      promise: null,
    };
  }, [activeSessionId, StudentgetId, ClasSectionId]);

  // Fetch school details
  useEffect(() => {
    const fetchSchoolDetails = async () => {
      try {
        const response = await fetch("https://api.mirai.healthcare/api/head/school-rule/school-automation");
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          setSchoolDetails(data[0]);
        }
      } catch (error) {
        console.error("Error fetching school details:", error);
      }
    };
    fetchSchoolDetails();
  }, []);

  const getPreviousUnpaidInstallments = (currentInstallment) => {
  const currentIndex = availableInstallments.findIndex(
    inst => inst.id === currentInstallment.id
  );

  if (currentIndex === -1) return [];

  const previousInstallments = availableInstallments.slice(0, currentIndex + 1);

  // Only unpaid installments
  return previousInstallments.filter(inst => {
    const data = allInstallmentsData[inst.id];
    if (!data) return false;
    const balance = calculateInstallmentTotal(inst);
    return !isInstallmentFullyPaid(inst) && balance > 0;
  });
};


  const generateJwtToken = (schema) => {
    const header = { alg: "HS256", typ: "JWT" };
    const payload = {
      schema: schema,
      exp: Math.floor(Date.now() / 1000) + (30 * 60),
    };
    const sHeader = JSON.stringify(header);
    const sPayload = JSON.stringify(payload);
    const token = KJUR.jws.JWS.sign("HS256", sHeader, sPayload, "token");
    return token;
  };

  const generatePaymentToken = (paymentData) => {
    const header = { alg: "HS256", typ: "JWT" };
    const payload = {
      paymentData,
      exp: Math.floor(Date.now() / 1000) + (10 * 60),
    };
    const sHeader = JSON.stringify(header);
    const sPayload = JSON.stringify(payload);
    return KJUR.jws.JWS.sign("HS256", sHeader, sPayload, "token");
  };

  const fetchFeeCycleData = async () => {
    try {
      const authToken = localStorage.getItem('token');
      const response = await fetch(
        `https://api.mirai.healthcare/api/fee-service/fee-cycles/${feeCycleId}`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-auth': authToken,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setFeeCycleData(data);
        return data;
      }
    } catch (err) {
      console.error('Error fetching fee cycle data:', err);
    }
    return null;
  };

  const generateInstallments = (feeCycle) => {
    if (!feeCycle) return [];

    const { type, session_start_month, session_end_month } = feeCycle;
    const installments = [];

    const currentYear = moment().year();

    let sessionStart, sessionEnd;
    if (session_start_month > session_end_month) {
      sessionStart = moment().month(session_start_month - 1).date(1).year(currentYear);
      sessionEnd = moment().month(session_end_month - 1).date(1).year(currentYear + 1);
    } else {
      sessionStart = moment().month(session_start_month - 1).date(1).year(currentYear);
      sessionEnd = moment().month(session_end_month - 1).date(1).year(currentYear);
    }

    let currentPeriodStart = sessionStart.clone();
    let installmentCount = 1;

    console.log('Generating installments for:', type, {
      sessionStart: sessionStart.format('YYYY-MM-DD'),
      sessionEnd: sessionEnd.format('YYYY-MM-DD')
    });

    switch (type.toLowerCase()) {
      case 'quarterly':
        while (currentPeriodStart.isBefore(sessionEnd)) {
          const quarterEnd = currentPeriodStart.clone().add(2, 'months').endOf('month');
          const startMonth = currentPeriodStart.month() + 1;
          const endMonth = quarterEnd.month() + 1;
          const months = [startMonth, startMonth + 1, startMonth + 2];

          installments.push({
            id: `quarter_${installmentCount}`,
            label: `${currentPeriodStart.format('MMM')}-${quarterEnd.format('MMM YYYY')}`,
            value: `quarter_${installmentCount}`,
            startMonth: startMonth,
            endMonth: endMonth,
            months: months,
            installmentNumber: installmentCount,
            cycleType: 'quarterly',
            periodStart: currentPeriodStart.format('YYYY-MM-DD'),
            periodEnd: quarterEnd.format('YYYY-MM-DD')
          });
          currentPeriodStart = currentPeriodStart.add(3, 'months');
          installmentCount++;
        }
        break;

      case 'halfyearly':
        while (currentPeriodStart.isBefore(sessionEnd)) {
          const halfYearEnd = currentPeriodStart.clone().add(5, 'months').endOf('month');
          const startMonth = currentPeriodStart.month() + 1;
          const endMonth = halfYearEnd.month() + 1;
          const months = Array.from({ length: 6 }, (_, i) => {
            let monthNum = startMonth + i;
            return monthNum > 12 ? monthNum - 12 : monthNum;
          });

          installments.push({
            id: `halfyear_${installmentCount}`,
            label: `${currentPeriodStart.format('MMM')}-${halfYearEnd.format('MMM YYYY')}`,
            value: `halfyear_${installmentCount}`,
            startMonth: startMonth,
            endMonth: endMonth,
            months: months,
            installmentNumber: installmentCount,
            cycleType: 'halfyearly',
            periodStart: currentPeriodStart.format('YYYY-MM-DD'),
            periodEnd: halfYearEnd.format('YYYY-MM-DD')
          });
          currentPeriodStart = currentPeriodStart.add(6, 'months');
          installmentCount++;
        }
        break;

      case 'yearly':
        const yearEnd = sessionEnd.clone().subtract(1, 'day');
        const months = Array.from({ length: 12 }, (_, i) => {
          let monthNum = session_start_month + i;
          return monthNum > 12 ? monthNum - 12 : monthNum;
        });

        installments.push({
          id: 'yearly_1',
          label: `${sessionStart.format('MMM YYYY')}-${yearEnd.format('MMM YYYY')}`,
          value: 'yearly_1',
          startMonth: session_start_month,
          endMonth: session_end_month,
          months: months,
          installmentNumber: 1,
          cycleType: 'yearly',
          periodStart: sessionStart.format('YYYY-MM-DD'),
          periodEnd: yearEnd.format('YYYY-MM-DD')
        });
        break;

      case 'monthly':
      default:
        currentPeriodStart = sessionStart.clone();
        while (currentPeriodStart.isSameOrBefore(sessionEnd, 'month')) {
          const monthNumber = currentPeriodStart.month() + 1;
          installments.push({
            id: `month_${monthNumber}_${currentPeriodStart.format('YYYY')}`,
            label: currentPeriodStart.format('MMMM YYYY'),
            value: monthNumber.toString(),
            startMonth: monthNumber,
            endMonth: monthNumber,
            months: [monthNumber],
            installmentNumber: installmentCount,
            cycleType: 'monthly',
            periodStart: currentPeriodStart.format('YYYY-MM-DD'),
            periodEnd: currentPeriodStart.clone().endOf('month').format('YYYY-MM-DD')
          });
          currentPeriodStart = currentPeriodStart.add(1, 'month');
          installmentCount++;
        }
        break;
    }

    console.log('Generated installments:', installments);
    return installments;
  };

  useEffect(() => {
    if (!feeCycleId || !studentId || !activeSessionId) {
      return;
    }

    const init = async () => {
      setLoading(true);
      try {
        const feeCycle = await fetchFeeCycleData();
        if (feeCycle) {
          const installments = generateInstallments(feeCycle);
          setAvailableInstallments(installments);
          if (installments.length > 0) {
            await fetchAllInstallmentsData(installments);
          }
        }
      } catch (err) {
        console.error('Error initializing fee data:', err);
        setError(err.message || 'Failed to load fee data');
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [feeCycleId, studentId, activeSessionId]);

  const classData = {
    class: Number(getRegistration?.data?.select_class),
  };
  const classLabel = allClass
    .filter(item => item.value === classData.class)
    .map(item => item.label)[0];

  const sessionData = {
    session: Number(studentDetails?.session),
  };
  const sessionLabel = session
    .filter(item => item?.value === sessionData?.session)
    .map(item => item?.label)[0];

  const calculateApprovalAmount = (approval, baseAmount) => {
    if (approval?.fee_discount_id && approval?.fee_discount) {
      const discountValue = parseFloat(approval.fee_discount.discount_value) || 0;
      if (approval.fee_discount.is_percentage) {
        return (baseAmount * discountValue) / 100;
      }
      return discountValue;
    }
    return parseFloat(approval?.amount) || 0;
  };

  // const fetchFeeDiscountApprovals = async (monthValue, feeCategoryId) => {
  //   if (!activeSessionId || !studentId || !feeCategoryId) {
  //     return [];
  //   }

  //   const cacheKey = `${activeSessionId}_${studentId}_${monthValue}_${feeCategoryId}`;
  //   if (discountApprovalCache.current.has(cacheKey)) {
  //     return discountApprovalCache.current.get(cacheKey);
  //   }

  //   if (!authtoken) {
  //     return [];
  //   }

  //   try {
  //     const response = await fetch(
  //       `https://api.mirai.healthcare/api/fee-service/fee_discount-approval?session_id=${activeSessionId}&student_id=${studentId}&month=${monthValue}&fee_category_id=${feeCategoryId}`,
  //       {
  //         method: 'GET',
  //         headers: {
  //           'Accept': 'application/json',
  //           'Content-Type': 'application/json',
  //           'x-auth': authtoken,
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const payload = await response.json();
  //     const approved = Array.isArray(payload?.message)
  //       ? payload.message.filter(item => item.status === 'Approved')
  //       : [];

  //     discountApprovalCache.current.set(cacheKey, approved);
  //     return approved;
  //   } catch (err) {
  //     console.error('Error fetching discount approvals:', err);
  //     discountApprovalCache.current.set(cacheKey, []);
  //     return [];
  //   }
  // };

  

  // const fetchMonthFeeData = async (monthValue) => {
  //   try {
  //     const authToken = localStorage.getItem('token');

  //     console.log('Fetching fee data for month:', monthValue);

  //     const response = await fetch(
  //       `https://api.mirai.healthcare/api/fee-service/fee-details/student?month=${monthValue}`,
  //       {
  //         method: 'GET',
  //         headers: {
  //           'Accept': 'application/json',
  //           'Content-Type': 'application/json',
  //           'x-auth': authToken,
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     const enrichedDetails = await applyDiscountApprovalsToFeeDetails(monthValue, data?.fee_details || []);
  //     const responseData = { ...data, fee_details: enrichedDetails };

  //     console.log(`Fee data for month ${monthValue}:`, responseData);
  //     return responseData;
  //   } catch (err) {
  //     console.error(`Error fetching fee data for month ${monthValue}:`, err);
  //     throw err;
  //   }
  // };

  const applyDiscountApprovalsToFeeDetails = async (monthValue, feeDetails = []) => {
    if (!Array.isArray(feeDetails) || feeDetails.length === 0) {
      return feeDetails || [];
    }

    const updatedFees = await Promise.all(
      feeDetails.map(async (fee) => {
        const categoryId = fee?.fee_configuration?.fee_category_id;
        if (!categoryId) {
          return fee;
        }

        const approvals = await fetchMonthFeeData(monthValue, categoryId);
        if (!approvals.length) {
          return fee;
        }

        const baseAmount = parseFloat(fee?.fee_configuration?.amount) || 0;
        const baseBalance = Number.isFinite(parseFloat(fee?.balance_due))
          ? parseFloat(fee.balance_due)
          : baseAmount;

        let totalAdjustment = 0;
        const adjustments = approvals.map(approval => {
          const value = calculateApprovalAmount(approval, baseAmount);
          const signedValue = approval?.fee_discount_id
            ? -value
            : approval?.is_incre
              ? value
              : -value;
          totalAdjustment += signedValue;

          return {
            id: approval.id,
            label: approval.descp || approval.fee_discount?.discount_type_name || 'Adjustment',
            amount: Math.abs(signedValue),
            isIncrease: signedValue >= 0,
          };
        });

        const adjustedAmount = Math.max(baseAmount + totalAdjustment, 0);
        const adjustedBalanceDue = Math.max(baseBalance + totalAdjustment, 0);

        return {
          ...fee,
          adjustments,
          adjusted_amount: adjustedAmount,
          adjusted_balance_due: adjustedBalanceDue,
          adjustments_total: totalAdjustment,
        };
      })
    );

    return updatedFees;
  };
  const buildMonthlyFeeMap = (feeDetails = []) => {
    const monthlyMap = {};
    feeDetails.forEach(fee => {
      const monthValue = Number(
        fee?.fee_month ??
        fee?.month ??
        fee?.fee_configuration?.fee_month ??
        fee?.fee_configuration?.month
      );
      if (Number.isFinite(monthValue)) {
        if (!monthlyMap[monthValue]) {
          monthlyMap[monthValue] = [];
        }
        monthlyMap[monthValue].push(fee);
      }
    });
    return monthlyMap;
  };

  const fetchAllFeeData = async () => {
    if (!activeSessionId || !StudentgetId || !ClasSectionId) return null;

    const cacheKey = `${activeSessionId}_${StudentgetId}_${ClasSectionId}`;
    const cache = feeDataCacheRef.current;

    if (cache.key === cacheKey && cache.data) {
      return cache.data;
    }

    if (cache.key === cacheKey && cache.promise) {
      return cache.promise;
    }

    const authToken = localStorage.getItem("token");
    if (!authToken) return null;

    const url =
      `https://api.mirai.healthcare/api/fee-service/fee-details/get-by-student-id-for-studentapp?session_id=${activeSessionId}&student_id=${StudentgetId}&class_section_id=${ClasSectionId}&month=1&month=2&month=3&month=4&month=5&month=6&month=7&month=8&month=9&month=10&month=11&month=12`;

    cache.key = cacheKey;
    cache.promise = fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "x-auth": authToken,
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log("API Raw Response All Fee:", data);
        cache.data = data;
        cache.monthlyMap = buildMonthlyFeeMap(data?.fee_details || []);
        return data;
      })
      .catch(err => {
        cache.key = null;
        cache.data = null;
        cache.monthlyMap = null;
        throw err;
      })
      .finally(() => {
        cache.promise = null;
      });

    return cache.promise;
  };

  const fetchMonthFeeData = async (monthValue) => {
    try {
      const data = await fetchAllFeeData();
      if (!data) {
        return { fee_details: [] };
      }

      if (!monthValue) {
        return data;
      }

      const monthlyMap = feeDataCacheRef.current.monthlyMap || buildMonthlyFeeMap(data?.fee_details || []);
      feeDataCacheRef.current.monthlyMap = monthlyMap;

      return {
        ...data,
        fee_details: monthlyMap[monthValue] || [],
        month: monthValue,
      };
    } catch (err) {
      console.error("Fetch Fee Error:", err);
      throw err;
    }
  };

const [summaryMetrics2, setSummaryMetrics] = useState({
  totalFee: 0,
  totalDue: 0,
  lateFee: 0,
  advanceFee: 0,
});

useEffect(() => {
  if (activeSessionId && StudentgetId && ClasSectionId) {
    const loadData = async () => {
      const data = await fetchMonthFeeData();
      if (data && data.fee_details) {
        const metrics = calculateSummaryMetrics(data.fee_details);

        const apiTotalPaid = Number(data.totalpaid || 0);

        setSummaryMetrics({
          ...metrics,
          totalPaid: apiTotalPaid,
          totalFee: metrics.totalDue + apiTotalPaid,
        });
      }
    };

    loadData();
  }
}, [activeSessionId, StudentgetId, ClasSectionId]);


const calculateSummaryMetrics = (feeDetails = []) => {
  let totalFee = 0;
  let totalDue = 0;
  let totalPaid = 0;
  let lateFee = 0;
  let advanceFee = 0;

  feeDetails.forEach(item => {
    const amount = Number(item.fee_configuration?.amount || 0);
    const paid = Number(item.total_paid || 0);
    const due = Number(item.balance_due || 0);

    // Total fee (sum of fee amounts)
    totalFee += amount;

    // Total due
    totalDue += due;

    // ⭐ Total paid (Fix: earlier missing)
    totalPaid += paid;

    // Late fee from collections
    if (item.collections && item.collections.length > 0) {
      item.collections.forEach(col => {
        lateFee += Number(col.fine_applied || 0);
      });
    }

    // Advance fee = if paid more than amount
    if (paid > amount) {
      advanceFee += (paid - amount);
    }
  });

  return {
    totalFee,
    totalDue,
    totalPaid,  // ⭐ Newly added
    lateFee,
    advanceFee,
  };
};



  const fetchInstallmentData = async (installment) => {
    try {
      setLoadingInstallments(prev => ({ ...prev, [installment.id]: true }));

      console.log('Fetching installment data:', installment);

      const monthlyData = {};
      const promises = installment.months.map(async (month) => {
        try {
          const data = await fetchMonthFeeData(month);
          monthlyData[month] = data;
        } catch (err) {
          monthlyData[month] = { error: err.message, fee_details: [] };
        }
      });

      await Promise.all(promises);

      const combinedData = {
        fee_details: [],
        period_months: installment.months,
        monthly_data: monthlyData,
        installment: installment,
        lastUpdated: new Date().toISOString()
      };

      installment.months.forEach(month => {
        if (monthlyData[month] && monthlyData[month].fee_details) {
          combinedData.fee_details.push(...monthlyData[month].fee_details.map(fee => ({
            ...fee,
            source_month: month
          })));
        }
      });

      console.log('Combined installment data:', combinedData);

      setAllInstallmentsData(prev => ({
        ...prev,
        [installment.id]: combinedData
      }));

      setFeesData(combinedData);
      setSelectedInstallment(installment);
    } catch (err) {
      console.error('Error fetching installment data:', err);
      setError(err.message || 'Failed to fetch installment data');
    } finally {
      setLoadingInstallments(prev => ({ ...prev, [installment.id]: false }));
    }
  };

  const fetchAllInstallmentsData = async (installments) => {
    try {
      setLoading(true);
      setError(null);

      console.log('Fetching data for all installments:', installments);

      const allData = {};

      for (const installment of installments) {
        try {
          setLoadingInstallments(prev => ({ ...prev, [installment.id]: true }));

          const monthlyData = {};
          const promises = installment.months.map(async (month) => {
            try {
              const data = await fetchMonthFeeData(month);
              monthlyData[month] = data;
            } catch (err) {
              monthlyData[month] = { error: err.message, fee_details: [] };
            }
          });

          await Promise.all(promises);

          const combinedData = {
            fee_details: [],
            period_months: installment.months,
            monthly_data: monthlyData,
            installment: installment,
            lastUpdated: new Date().toISOString()
          };

          installment.months.forEach(month => {
            if (monthlyData[month] && monthlyData[month].fee_details) {
              combinedData.fee_details.push(...monthlyData[month].fee_details.map(fee => ({
                ...fee,
                source_month: month
              })));
            }
          });

          allData[installment.id] = combinedData;

        } catch (err) {
          console.error(`Error fetching data for installment ${installment.id}:`, err);
          allData[installment.id] = { error: err.message, fee_details: [] };
        } finally {
          setLoadingInstallments(prev => ({ ...prev, [installment.id]: false }));
        }
      }

      setAllInstallmentsData(allData);

      if (installments.length > 0) {
        setFeesData(allData[installments[0].id]);
        setSelectedInstallment(installments[0]);
      }

    } catch (err) {
      console.error('Error fetching all installments data:', err);
      setError(err.message || 'Failed to fetch installments data');
    } finally {
      setLoading(false);
    }
  };

  const getFeeAmount = (fee) => {
    if (!fee) return 0;
    const amount = typeof fee?.adjusted_amount === 'number'
      ? fee.adjusted_amount
      : parseFloat(fee?.fee_configuration?.amount);
    return Number.isFinite(amount) ? amount : 0;
  };

  const getOriginalFeeAmount = (fee) => {
    if (!fee) return 0;
    const raw = parseFloat(fee?.fee_configuration?.amount);
    if (Number.isFinite(raw)) {
      return raw;
    }
    return getFeeAmount(fee);
  };

  const getDiscountedFeeAmount = (fee) => {
    if (!fee) return 0;
    const balance = parseFloat(fee?.balance_due);
    if (Number.isFinite(balance) && balance > 0) {
      return balance;
    }
    const payable = parseFloat(fee?.payable);
    if (Number.isFinite(payable)) {
      return payable;
    }
    const adjusted = typeof fee?.adjusted_amount === 'number' ? fee.adjusted_amount : NaN;
    if (Number.isFinite(adjusted)) {
      return adjusted;
    }
    return getFeeAmount(fee);
  };

  const getFeeBalanceDue = (fee) => {
    if (!fee) return 0;
    const balance = typeof fee?.adjusted_balance_due === 'number'
      ? fee.adjusted_balance_due
      : parseFloat(fee?.balance_due);
    if (Number.isFinite(balance)) {
      return balance;
    }
    return getFeeAmount(fee);
  };

  const getFeeTotalPaid = (fee) => {
    if (!fee) return 0;
    const paid = parseFloat(fee?.total_paid);
    if (Number.isFinite(paid)) {
      return paid;
    }
    const collectedPaid = parseFloat(fee?.collections?.[0]?.amount_paid);
    return Number.isFinite(collectedPaid) ? collectedPaid : 0;
  };

  const getFeePayableAmount = (fee) => {
    if (!fee) return 0;
    const payable = parseFloat(fee?.payable);
    if (Number.isFinite(payable)) {
      return payable;
    }
    return getFeeAmount(fee);
  };

  const isFeePartiallyPaid = (fee) => {
    if (!fee) return false;
    const totalPaid = getFeeTotalPaid(fee);
    const balanceDue = getFeeBalanceDue(fee);
    return fee?.has_paid !== true && totalPaid > 0 && balanceDue > 0;
  };

  const isFeePaid = (fee) => {
    if (fee.has_paid === true) return true;
    if (getFeeBalanceDue(fee) <= 0 && getFeeTotalPaid(fee) > 0) return true;
    return false;
  };

  // const handleInstallmentSelect = (installment) => {
  //   const installmentData = allInstallmentsData[installment.id];
  //   if (!installmentData || isInstallmentFullyPaid(installment)) {
  //     Swal.fire({
  //       icon: 'info',
  //       title: 'Already Paid',
  //       text: 'This installment is already fully paid or data not loaded.',
  //       confirmButtonText: 'OK',
  //       confirmButtonColor: '#3085d6'
  //     });
  //     return;
  //   }

  //   setSelectedInstallments(prev => {
  //     const isSelected = prev.some(item => item.id === installment.id);
  //     if (isSelected) {
  //       return prev.filter(item => item.id !== installment.id);
  //     } else {
  //       return [...prev, { ...installment, selectable: true }];
  //     }
  //   });
  // };



  const handleInstallmentSelect = (installment) => {
    const balance = calculateInstallmentTotal(installment);
    if (isInstallmentFullyPaid(installment) || balance <= 0) {
      return;
    }

  const unpaidInstallments = getPreviousUnpaidInstallments(installment);

  if (unpaidInstallments.length === 0) {
    Swal.fire({
      icon: 'info',
      title: 'No Due',
      text: 'All previous installments are already paid.',
    });
    return;
  }

  setSelectedInstallments(unpaidInstallments);

  // Optional UX
  Swal.fire({
    icon: 'info',
    title: 'Auto Selected',
    text: 'Previous unpaid months also selected automatically.',
    timer: 1500,
    showConfirmButton: false,
  });
};


const getFirstUnpaidMonth = () => {
  for (let inst of availableInstallments) {
    const instData = allInstallmentsData[inst.id];
    if (!instData) continue;

    for (let month of inst.months) {
      const monthData = instData.monthly_data[month];

      const isPaid = monthData?.fee_details?.every(fee => isFeePaid(fee));

      if (!isPaid) {
        return { inst, month, data: monthData };
      }
    }
  }
  return null;
};

const firstUnpaid = getFirstUnpaidMonth();

const getUnpaidMonths = () => {
  const months = [];

  availableInstallments.forEach(inst => {
    const instData = allInstallmentsData[inst.id];
    if (!instData) return;

    inst.months.forEach(month => {
      const fees = instData.monthly_data?.[month]?.fee_details || [];

      const isPaid = fees.every(fee => isFeePaid(fee));

      if (!isPaid) {
        months.push({
          month,
          installment: inst,
          data: instData.monthly_data[month]
        });
      }
    });
  });

  return months;
};

const unpaidMonths = getUnpaidMonths();

const defaultMonth =
  selectedInstallments.length > 0
    ? null
    : unpaidMonths.length > 0
    ? unpaidMonths[0]
    : null;


  const handleInstallmentClick = (installment) => {
    const existingData = allInstallmentsData[installment.id];
    if (existingData) {
      setFeesData(existingData);
      setSelectedInstallment(installment);
    } else {
      fetchInstallmentData(installment);
    }
  };

  const handleRefreshInstallment = (installment, e) => {
    e.stopPropagation();
    fetchInstallmentData(installment);
  };

  const handleFeeReceiptNavigation = () => {
    if (studentDetails?.id) {
      navigate('/FeeHistory', { state: { studentId: studentDetails.id } });
    } else {
      Swal.fire('Error', 'Student details not loaded. Please refresh.', 'error');
    }
  };

  const handleFeeAccuracyNavigation = () => {
    if (studentDetails?.id) {
      navigate('/FeeAccuracyReport', { state: { studentId: studentDetails.id } });
    } else {
      Swal.fire('Error', 'Student details not loaded. Please refresh.', 'error');
    }
  };

  const handleShowPaymentSection = () => {
    setShowPaymentSection(true);
    setTimeout(() => {
      document.getElementById('payment-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  const handlePayNow = async (installmentsToPay = selectedInstallments) => {
    if (installmentsToPay.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Installment Selected',
        text: 'Please select at least one installment to pay.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6'
      });
      return;
    }

    if (!studentDetails || !schema) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Student details or schema missing. Please refresh and try again.',
        confirmButtonText: 'OK',
      });
      return;
    }

    const totalAmount = installmentsToPay.reduce((total, installment) => {
      return total + calculateInstallmentTotal(installment);
    }, 0);

    if (totalAmount === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Amount Due',
        text: 'No outstanding fees in selected installments.',
        confirmButtonText: 'OK',
      });
      return;
    }

    const feeColl = [];
    let sessionId = null;

    installmentsToPay.forEach(installment => {
      const installmentData = allInstallmentsData[installment.id];
      if (installmentData) {
        installment.months.forEach(month => {
          if (installmentData.monthly_data[month] && installmentData.monthly_data[month].fee_details) {
            installmentData.monthly_data[month].fee_details.forEach(fee => {
              const balanceDue = getFeeBalanceDue(fee);
              if (!isFeePaid(fee) && balanceDue > 0) {
                if (!sessionId) {
                  sessionId = fee.fee_configuration?.session_id;
                }
                const payableAmount = getFeePayableAmount(fee);
                const amountDueForPayload = Number.isFinite(payableAmount)
                  ? parseFloat(payableAmount)
                  : parseFloat(balanceDue);
                feeColl.push({
                  session_id: fee.fee_configuration?.session_id,
                  student_id: studentDetails.id,
                  class_section_id: studentDetails.class_section_id,
                  stream_id: studentDetails.cls_sec?.stream_id || 1,
                  fee_category_id: fee.fee_configuration?.fee_category_id,
                  fee_cycle_id: feeCycleId,
                  amount_due: amountDueForPayload,
                  amount_paid: amountDueForPayload,
                  amt_paid: parseFloat(balanceDue),
                  amount_balanced: 0,
                  payment_mode: schoolDetails.PaymentMethod === "SabPaisa" ? "SabPaisa" : "Payu",
                  payment_date: new Date().toISOString().split("T")[0],
                  fee_month: month,
                });
              }
            });
          }
        });
      }
    });

    // const payload = {
    //   session_id: sessionId,
    //   class_section_id: studentDetails.class_section_id,
    //   student_id: studentDetails.id,
    //   payment_mode: "Payu",
    //   amount: totalAmount,
    //   submission_date: new Date().toISOString().split("T")[0],
    //   fee_coll: feeColl,
    // };

    const payload = {
  session_id: sessionId,
  class_section_id: studentDetails.class_section_id,
  student_id: studentDetails.id,
  payment_mode: schoolDetails.PaymentMethod === "SabPaisa" ? "SabPaisa" : "Payu",
  amount: totalAmount,
  submission_date: new Date().toISOString().split("T")[0],
  fee_coll: feeColl, // change here
};


    const jwtToken = generateJwtToken(schema);

    setPaying(true);
    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/fee-service/fee-collections",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-auth": jwtToken,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      console.log("Fee Collections Response:", data);

      if (response.ok && data.status && Array.isArray(data.data) && Array.isArray(data.data[0])) {
        const feeCollectionIds = data.data[0].map(item => item.id);
        const feeCollHeaderIds = [
          ...new Set(
            data.data[0]
              .map(item => item.fee_coll_header_id)
              .filter(id => id !== null && id !== undefined)
          ),
        ];

        const payuJwtToken = generateJwtToken(schema);

        const securePaymentPayload = {
          amount: totalAmount.toString(),
          productinfo: "Fee Collection",
          firstname: studentDetails.student_full_name || "",
          email: studentDetails.father_email || "default@example.com",
          phone: studentDetails.father_mobile_no || "0000000000",
          authToken: payuJwtToken,
          sessionId: payload.session_id.toString(),
          classSectionId: payload.class_section_id.toString(),
          feeCollectionIds,
          feeCollHeaderIds,
          paymentMethod: schoolDetails.PaymentMethod || "PayU",
        };
        const paymentToken = generatePaymentToken(securePaymentPayload);
        // const paymentUrl = `/pay-u-payment?paymentToken=${encodeURIComponent(paymentToken)}`;
        const paymentUrl = `${window.location.origin}/pay-u-payment?paymentToken=${encodeURIComponent(paymentToken)}`;
        
        // window.open(paymentUrl, "_blank");
        // window.open(paymentUrl, "_blank");
        window.location.href = paymentUrl;

        Swal.fire({
          icon: "success",
          title: "Payment Initiated",
          text: `Redirecting to PayU for payment of ${formatCurrency(totalAmount)}.`,
          confirmButtonText: "OK",
        });

        if (availableInstallments.length > 0) {
          await fetchAllInstallmentsData(availableInstallments);
        }

        setSelectedInstallments(prev =>
          prev.filter(item => !installmentsToPay.some(sel => sel.id === item.id))
        );
      } else {
        throw new Error(data.message || "Failed to create fee collections");
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "An error occurred while processing the payment.",
        confirmButtonText: "OK",
      });
    } finally {
      setPaying(false);
    }
  };

  const handlePayInstallment = async (installment) => {
    if (!allInstallmentsData[installment.id]) {
      Swal.fire({
        icon: 'info',
        title: 'Data Loading',
        text: 'Please open the installment to load its details before paying.',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (isInstallmentFullyPaid(installment)) {
      Swal.fire({
        icon: 'info',
        title: 'Already Paid',
        text: 'This installment is already fully paid.',
        confirmButtonText: 'OK',
      });
      return;
    }

    await handlePayNow([installment]);
  };

  const calculateInstallmentTotal = (installment) => {
    const installmentData = allInstallmentsData[installment.id];
    if (!installmentData) return 0;

    let total = 0;
    installment.months.forEach(month => {
      if (installmentData.monthly_data[month] && installmentData.monthly_data[month].fee_details) {
        installmentData.monthly_data[month].fee_details.forEach(fee => {
          if (!isFeePaid(fee)) {
            total += getFeeBalanceDue(fee);
          }
        });
      }
    });
    return total;
  };

  const calculateTotalSelectedAmount = () => {
    return selectedInstallments.reduce((total, installment) => {
      return total + calculateInstallmentTotal(installment);
    }, 0);
  };

  const summaryMetrics = useMemo(() => {
    const totals = {
      totalFee: 0,
      totalPaid: 0,
      totalDue: 0,
      lateFee: 0,
      advanceFee: 0
    };
    const processedIds = new Set();

    Object.values(allInstallmentsData).forEach(installmentData => {
      installmentData?.fee_details?.forEach(fee => {
        const uniqueKey = `${fee.id || fee.fee_configuration_id || fee.fee_configuration?.id || ''}_${fee.source_month || ''}`;
        if (processedIds.has(uniqueKey)) return;
        processedIds.add(uniqueKey);

        const amount = getFeeAmount(fee);
        totals.totalFee += amount;

        if (isFeePaid(fee)) {
          totals.totalPaid += amount;
        } else {
          const dueAmount = getFeeBalanceDue(fee);
          totals.totalDue += dueAmount;
        }

        const lateAmount = parseFloat(fee.late_fee || fee.fee_configuration?.late_fee || 0);
        if (!Number.isNaN(lateAmount)) {
          totals.lateFee += lateAmount;
        }

        const advanceAmount = parseFloat(fee.advance_fee || 0);
        if (!Number.isNaN(advanceAmount)) {
          totals.advanceFee += advanceAmount;
        }
      });
    });

    return totals;
  }, [allInstallmentsData]);

  const getPaymentStatus = (fee) => {
    if (isFeePaid(fee)) return { text: 'Paid', variant: 'success' };
    if (isFeePartiallyPaid(fee)) return { text: 'Partially Paid', variant: 'warning' };
    if (fee.collections?.[0]?.payment_status === 'pending') return { text: 'Pending', variant: 'warning' };
    return { text: 'Unpaid', variant: 'danger' };
  };

  const getDiscountMeta = (fee) => {
    const studentDiscount = fee?.fee_configuration?.student_discount || fee?.student_discount;
    if (!studentDiscount) return null;

    const discount = studentDiscount.discount || {};
    const name = studentDiscount.name || discount.discount_type_name || 'Discount';
    const isPercentage = studentDiscount.mode === 'Percentage' || discount.is_percentage === true;
    const rawValue = studentDiscount.value ?? discount.discount_value;
    const numericValue = Number(rawValue);

    return {
      name,
      isPercentage,
      value: Number.isNaN(numericValue) ? rawValue : numericValue,
    };
  };

  const formatDiscountValue = (meta) => {
    if (!meta) return '';
    if (meta.isPercentage) {
      return `${meta.value}%`;
    }
    return typeof meta.value === 'number' ? formatCurrency(meta.value) : meta.value;
  };

  const getApprovalAdjustments = (fee) => {
    const approvals = Array.isArray(fee?.student_discount_approval)
      ? fee.student_discount_approval
      : [];
    return approvals
      .filter(item => item?.status === 'Approved')
      .map(item => ({
        id: item.id,
        isIncrease: item.is_incre === true,
        amount: Number(item.amount) || 0,
        label: item.descp || 'Adjustment',
      }))
      .filter(item => item.amount > 0);
  };

  const formatCurrency = (amount) => {
    const numericValue = Number(amount);
    if (Number.isNaN(numericValue)) {
      return '₹0';
    }
    return `₹${numericValue.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const getMonthName = (monthNumber) => {
    return moment().month(monthNumber - 1).format('MMM');
  };

  const isInstallmentFullyPaid = (installment) => {
    const installmentData = allInstallmentsData[installment.id];
    if (!installmentData) return false;

    for (let month of installment.months) {
      if (installmentData.monthly_data[month] && installmentData.monthly_data[month].fee_details) {
        for (let fee of installmentData.monthly_data[month].fee_details) {
          if (!isFeePaid(fee)) {
            return false;
          }
        }
      }
    }
    return true;
  };

  const getInstallmentPaymentStatus = (installment) => {
    const installmentData = allInstallmentsData[installment.id];

    if (!installmentData) {
      return { text: 'Loading...', variant: 'secondary', icon: FaSync };
    }

    if (isInstallmentFullyPaid(installment)) {
      return { text: 'Fully Paid', variant: 'success', icon: FaCheck };
    }

    const hasPartialPayment = installment.months.some(month =>
      (installmentData.monthly_data[month]?.fee_details || []).some(fee => isFeePartiallyPaid(fee))
    );
    if (hasPartialPayment) {
      return { text: 'Partially Paid', variant: 'warning', icon: FaExclamationTriangle };
    }

    const unpaidCount = getUnpaidFeesCount(installment);
    const totalCount = getTotalFeesCount(installment);

    if (unpaidCount === totalCount) {
      return { text: 'Unpaid', variant: 'danger', icon: FaTimesCircle };
    } else {
      return { text: `Partially Paid`, variant: 'warning', icon: FaExclamationTriangle };
    }
  };

  const getUnpaidFeesCount = (installment) => {
    const installmentData = allInstallmentsData[installment.id];
    if (!installmentData) return 0;

    let unpaidCount = 0;
    installment.months.forEach(month => {
      if (installmentData.monthly_data[month] && installmentData.monthly_data[month].fee_details) {
        installmentData.monthly_data[month].fee_details.forEach(fee => {
          if (!isFeePaid(fee)) {
            unpaidCount++;
          }
        });
      }
    });
    return unpaidCount;
  };

  const getTotalFeesCount = (installment) => {
    const installmentData = allInstallmentsData[installment.id];
    if (!installmentData) return 0;

    let totalCount = 0;
    installment.months.forEach(month => {
      if (installmentData.monthly_data[month] && installmentData.monthly_data[month].fee_details) {
        totalCount += installmentData.monthly_data[month].fee_details.length;
      }
    });
    return totalCount;
  };

  const hasDiscountApplied = (installmentData) => {
    if (!installmentData) return false;
    return Object.values(installmentData.monthly_data || {}).some(monthData =>
      monthData?.fee_details?.some(fee =>
        fee.adjustments?.some(adj => !adj.isIncrease)
      )
    );
  };

  const getPaidAmount = (installment) => {
    const installmentData = allInstallmentsData[installment.id];
    if (!installmentData) return 0;

    let paidAmount = 0;
    installment.months.forEach(month => {
      if (installmentData.monthly_data[month] && installmentData.monthly_data[month].fee_details) {
        installmentData.monthly_data[month].fee_details.forEach(fee => {
          paidAmount += getFeeTotalPaid(fee);
        });
      }
    });
    return paidAmount;
  };

  const getInstallmentDueDate = (installment) => {
    const installmentData = allInstallmentsData[installment.id];
    if (!installmentData?.monthly_data) return null;

    const dueDates = [];
    installment.months.forEach(month => {
      const monthFees = installmentData.monthly_data[month]?.fee_details || [];
      monthFees.forEach(fee => {
        if (fee?.due_date) {
          dueDates.push(moment(fee.due_date));
        }
      });
    });

    if (dueDates.length === 0) return null;

    const earliestDueDate = dueDates.reduce((earliest, current) =>
      current.isBefore(earliest) ? current : earliest
    );
    return earliestDueDate.isValid() ? earliestDueDate.format('DD MMM YYYY') : null;
  };

  const getCycleTypeLabel = (type) => {
    switch (type?.toLowerCase()) {
      case 'quarterly': return 'Quarterly';
      case 'halfyearly': return 'Half-Yearly';
      case 'yearly': return 'Yearly';
      case 'monthly': return 'Monthly';
      default: return type;
    }
  };

  const InstallmentCard = ({ installment, isSelected, onSelect, onClick, selectedCount }) => {
    const installmentData = allInstallmentsData[installment.id];
    const isFullyPaid = isInstallmentFullyPaid(installment);
    const isLoading = loadingInstallments[installment.id];
    const hasData = !!installmentData;
    const totalAmount = calculateInstallmentTotal(installment);
    const paidAmount = getPaidAmount(installment);
    const paymentStatus = getInstallmentPaymentStatus(installment);
    const StatusIcon = paymentStatus.icon;
    const installmentDueDate = getInstallmentDueDate(installment);
    const progressTotal = paidAmount + totalAmount;
    const progressPercent = progressTotal === 0 ? 0 : (paidAmount / progressTotal) * 100;
    const cycleType = installment?.cycleType?.toLowerCase();
    const feeType = feeCycleData?.type?.toLowerCase();
    const isMultiSelected = selectedCount > 1;

    const isValidCycle =
      ["monthly", "quarterly", "halfyearly", "yearly"].includes(cycleType) ||
      ["monthly", "quarterly", "halfyearly", "yearly"].includes(feeType);

    const showInstallmentPayButton = isValidCycle && !isFullyPaid && hasData;
    const showDiscountTag = hasDiscountApplied(installmentData);

    const isSelectedInstallment = selectedInstallments.some(
  item => item.id === installment.id
);
   

    return (
      <Card className={`mb-3 installment-card ${isSelected ? 'selected' : ''} ${isFullyPaid ? 'fully-paid' : ''}`}
        style={{
          cursor: 'pointer',
          border: isSelected ? '2px solid #007bff' : isFullyPaid ? '1px solid #28a745' : '1px solid #e9ecef',
          transition: 'all 0.2s ease',
          opacity: isFullyPaid ? 0.8 : 1
        }}
       
      >
        <Card.Body className="p-3">
          <div  onClick={() => onClick(installment)}>
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-md-between gap-3">
            <div className="d-flex align-items-center flex-grow-1 w-100 w-md-auto">
              {/* <Form.Check
                type="checkbox"
                checked={isSelected}
                onChange={(e) => {
                  e.stopPropagation();
                  onSelect(installment);
                }}
                onClick={(e) => e.stopPropagation()}
                disabled={isFullyPaid || !hasData}
                className="me-3 me-md-2"
                id={`installment-${installment.id}`}
              /> */}

              <Form.Check
  type="checkbox"
    className="custom-checkbox11"

  checked={selectedInstallments.some(item => item.id === installment.id)}
  onChange={(e) => {
    e.stopPropagation();
    handleInstallmentSelect(installment);
  }}
  onClick={(e) => e.stopPropagation()}
  disabled={isFullyPaid || !hasData || totalAmount <= 0}
/>

              <div className="flex-grow-1 w-100">
                <div className="d-flex align-items-center mb-1 flex-wrap">
                  <h6 className="mb-0 fw-bold me-2">{installment.label}</h6>
                  {isFullyPaid && (
                    <FaCheck className="text-success" size={30} />
                  )}
                  {isLoading && (
                    <Spinner animation="border" size="sm" className="ms-2" />
                  )}
                </div>
                <div className="d-flex flex-column flex-md-row align-items-md-center gap-2 flex-wrap">
                  <Badge bg="info" className="fs-12 mb-1 mb-md-0">
                    {getCycleTypeLabel(installment.cycleType)} {installment.installmentNumber}
                  </Badge>
                  <span className="text-muted small">
                    {installment.months.map(month => getMonthName(month)).join(', ')}
                  </span>
                  {showDiscountTag && (
                    <Badge bg="success" className="fs-12">
                      Discount Applied
                    </Badge>
                  )}
                  {!hasData && (
                    <Badge bg="secondary" className="fs-12">
                      <FaEyeSlash size={8} className="me-1" />
                      Click to load
                    </Badge>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex flex-column align-items-md-end text-md-end gap-1 w-100 w-md-auto">
              <div className={`text-warning small fw-bold ${isFullyPaid ? 'text-success' : 'text-dark'}`}>
                {formatCurrency(totalAmount)}
              </div>

              {paidAmount > 0 && (
                <div className="text-success small">
                  Paid: {formatCurrency(paidAmount)}
                </div>
              )}
              {installmentDueDate && (
                <div className="text-muted small">
                  Due: {installmentDueDate}
                </div>
              )}
              <Badge
                bg={paymentStatus.variant}
                className="fs-12 d-flex align-items-center gap-1 justify-content-md-end"
              >
                <StatusIcon size={10} />
                {paymentStatus.text}
              </Badge>
            </div>

            <Button
              variant="outline-secondary"
              size="sm"
              className="ms-md-2 mt-2 mt-md-0 w-100 w-md-auto"
              onClick={(e) => handleRefreshInstallment(installment, e)}
              disabled={isLoading}
            >
              <FaSync className={isLoading ? 'fa-spin' : ''} size={12} />
            </Button>
          </div>

          {hasData && (
            <div className="mt-3">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-2 gap-2">
                <small className="text-muted">Payment Progress</small>
                <small className="text-muted text-md-end">
                  {getUnpaidFeesCount(installment)}/{getTotalFeesCount(installment)} fees pending
                </small>
              </div>
              <div className="progress" style={{ height: '6px' }}>
                <div
                  className="progress-bar bg-success"
                  style={{
                    width: `${progressPercent}%`
                  }}
                />
              </div>
            </div>
          )}

          {showInstallmentPayButton && (
            <div className="mt-3 d-flex justify-content-end">
              <Button
                variant="primary"
                size="sm"
                className="w-100 w-md-auto"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePayInstallment(installment);
                }}
                // disabled={paying || totalAmount === 0}
                //  disabled={paying || totalAmount === 0 || isMultiSelected}
                //  disabled={paying || totalAmount <= 0 || selectedInstallments.length > 1}
                 disabled={
    paying ||
    totalAmount <= 0 ||
    isMultiSelected || 
    !isSelectedInstallment
  }
              >
                <FaCreditCard className="me-2" size={12} />
                Pay Now ({formatCurrency(totalAmount)})
              </Button>
            </div>
          )}
          </div>
        </Card.Body>
      </Card>
    );
  };

  const InstallmentFeeBreakdown = ({ installment, data }) => {
    if (!data || !Array.isArray(data.fee_details) || data.fee_details.length === 0) {
      return (
        <div className="text-center text-muted py-3">
          No fee breakdown details available.
        </div>
      );
    }

    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const uniqueMonths = [];
    data.fee_details.forEach((fee) => {
      const m = Number(fee.source_month || fee.month);
      if (m && !uniqueMonths.includes(m)) {
        uniqueMonths.push(m);
      }
    });

    return (
      <>
        {uniqueMonths.map((m, index) => {
          const monthName = monthNames[m - 1] || `Month ${m}`;
          const itemsForMonth = data.fee_details.filter(
            (fee) => Number(fee.source_month || fee.month) === m
          );

          return (
            <div
              key={m}
              style={{
                marginBottom: index === uniqueMonths.length - 1 ? "0" : "25px",
              }}
            >
              <div
                style={{
                  fontWeight: "700",
                  color: "#1e293b",
                  fontSize: "14px",
                  marginBottom: "12px",
                  paddingLeft: "10px",
                  borderLeft: "4px solid #0d6efd",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {monthName}
              </div>
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead>
                    <tr
                      style={{
                        background: "#f7f9fc",
                      }}
                    >
                      <th>Fee Type</th>
                      <th>Payable</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemsForMonth.map((fee, idx) => {
                      const balanceDue = getFeeBalanceDue(fee);
                      const payable = getFeePayableAmount(fee);
                      const feeName = (fee.fee_configuration?.category_name || "Fee").split(" (")[0];

                      return (
                        <tr key={idx}>
                          <td className="fw-semibold">
                            {feeName}
                          </td>
                          <td>{formatCurrency(payable)}</td>
                          <td
                            style={{
                              fontWeight: "600",
                              color: balanceDue > 0 ? "#b45309" : "#198754",
                            }}
                          >
                            {formatCurrency(balanceDue)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const getInstallmentMetrics = (installment) => {
    const installmentData = allInstallmentsData[installment.id];
    if (!installmentData) {
      return { total: 0, paid: 0, balance: 0, due_date: null };
    }

    let paid = 0;
    let balance = 0;
    let dueDate = null;

    installment.months.forEach(month => {
      if (installmentData.monthly_data[month] && installmentData.monthly_data[month].fee_details) {
        installmentData.monthly_data[month].fee_details.forEach(fee => {
          paid += getFeeTotalPaid(fee);
          balance += getFeeBalanceDue(fee);

          if (!dueDate && fee.due_date) {
            dueDate = fee.due_date;
          }
        });
      }
    });

    return { total: paid + balance, paid, balance, due_date: dueDate };
  };

  const renderStudentDetails = () => {
    if (!studentDetails) return null;

    const {
      student_full_name,
      admission_num,
      father_full_name,
      father_mobile_no,
      father_email,
      mother_full_name,
      mother_mobile_no,
      class_section_id,
    } = studentDetails;

    const classSection = classSectionMap[class_section_id] || `ID: ${class_section_id}`;

    return (
      <div
        className="student-details-card"
        style={{
          background: "#fff",
          borderRadius: "16px",
          padding: "25px",
          marginBottom: "25px",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <h4
          style={{
            marginBottom: "20px",
            fontWeight: "700",
            color: "#222",
          }}
        >
          Student Details
        </h4>

        <div className="row">
          <div className="col-6 col-md-6 mb-3">
            <label className="fw-bold text-muted">Student Name</label>
            <div className="mt-1" style={{ color: "#333", fontWeight: "500" }}>
              {student_full_name || "N/A"}
            </div>
          </div>

          <div className="col-6 col-md-6 mb-3">
            <label className="fw-bold text-muted">Admission No.</label>
            <div className="mt-1" style={{ color: "#333", fontWeight: "500" }}>
              {admission_num || "N/A"}
            </div>
          </div>

          <div className="col-6 col-md-6 mb-3">
            <label className="fw-bold text-muted">Father Name</label>
            <div className="mt-1" style={{ color: "#333", fontWeight: "500" }}>
              {father_full_name || "N/A"}
            </div>
          </div>

          <div className="col-6 col-md-6 mb-3">
            <label className="fw-bold text-muted">Mobile Number</label>
            <div className="mt-1" style={{ color: "#333", fontWeight: "500" }}>
              {father_mobile_no || "N/A"}
            </div>
          </div>

          <div className="col-6 col-md-6 mb-3">
            <label className="fw-bold text-muted">Email</label>
            <div className="mt-1" style={{ color: "#333", fontWeight: "500" }}>
              {father_email || "N/A"}
            </div>
          </div>

          <div className="col-6 col-md-6 mb-3">
            <label className="fw-bold text-muted">Mother Name</label>
            <div className="mt-1" style={{ color: "#333", fontWeight: "500" }}>
              {mother_full_name || "N/A"}
            </div>
          </div>

          <div className="col-6 col-md-6 mb-3">
            <label className="fw-bold text-muted">Mother Mobile</label>
            <div className="mt-1" style={{ color: "#333", fontWeight: "500" }}>
              {mother_mobile_no || "N/A"}
            </div>
          </div>

          <div className="col-6 col-md-6 mb-3">
            <label className="fw-bold text-muted">Class Section</label>
            <div className="mt-1" style={{ color: "#333", fontWeight: "500" }}>
              {classSection || "N/A"}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const paidPercent = summaryMetrics2.totalFee > 0
    ? Math.min(Math.round((summaryMetrics2.totalPaid / summaryMetrics2.totalFee) * 100), 100)
    : 0;

  const summaryCardsData = [
    {
      title: 'Total Fee*',
      value: summaryMetrics2.totalFee,
      icon: FaMoneyBillWave,
      bg: '#eef2ff',
      border: '#cfd7ff'

    },
    {
      title: 'Total Due*',
      value: summaryMetrics2.totalDue,
      icon: FaCalendarDay,
      bg: '#fff1f1',
      border: '#ffd1d1'
    },
    // {
    //   title: 'Late Fee*',
    //   value: summaryMetrics2.lateFee,
    //   icon: FaTimesCircle,
    //   bg: '#fff7ec',
    //   border: '#ffe0b2'
    // },
    // {
    //   title: 'Advance Fee*',
    //   value: summaryMetrics2.advanceFee,
    //   icon: FaCreditCard,
    //   bg: '#f0fff4',
    //   border: '#c3f0d2'
    // }
  ];

  // Main loading state
  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <Header />
          <Container fluid className="py-4">
            <Card className="border-0 shadow-sm rounded-4">
              <Card.Body className="text-center py-5">
                <Spinner animation="border" variant="primary" className="mb-3" size="lg" />
                <h5 className="text-dark">Loading Fee Data</h5>
                <p className="text-muted small">Please wait while we load your fee information...</p>
              </Card.Body>
            </Card>
          </Container>
        </div>
      </div>
    );
  }

  

  
  return (
    <div className="page-wrapper">
      <div className="content">
        <Header />
         <style>
{`
  .custom-checkbox11 .form-check-input {
    width: 25px !Important;
    height: 25px !Important;
    margin-right: 10px;
    cursor: pointer;
  }
  .mobile-icon {
    display: none !important;
  }
  .desktop-icon {
    display: inline-flex !important;
  }
  @media (max-width: 767px) {
    .mobile-icon {
      display: inline-flex !important;
    }
    .desktop-icon {
      display: none !important;
    }
    .fee-collection-wrapper {
      padding: 10px 0px !important;
      overflow-x: hidden !important;
    }
    .student-details-card {
      padding: 15px 10px !important;
      border-radius: 0px !important;
      margin-bottom: 15px !important;
      box-shadow: none !important;
      border-left: none !important;
      border-right: none !important;
    }
    .student-details-card label {
      font-size: 11px !important;
    }
    .student-details-card .mt-1 {
      font-size: 13px !important;
      word-break: break-all !important;
    }
    .installments-card {
      padding: 15px 4px !important;
      border-radius: 0px !important;
      box-shadow: none !important;
      border-left: none !important;
      border-right: none !important;
    }
    .fee-collection-wrapper .row {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .fee-collection-wrapper .row > [class*="col-"] {
      padding-left: 6px !important;
      padding-right: 6px !important;
    }
    /* Prevent horizontal scrolling in Fee Installments */
    .fee-collection-wrapper .table-responsive {
      overflow-x: hidden !important;
    }
    .fee-collection-wrapper table {
      width: 100% !important;
      table-layout: fixed !important;
    }
    .fee-collection-wrapper th,
    .fee-collection-wrapper td {
      padding: 6px 3px !important;
      font-size: 11px !important;
      word-break: break-word !important;
    }
    /* Control column widths for parent table */
    .installments-card table thead th:nth-child(1),
    .installments-card table tr.parent-row td:nth-child(1) {
      width: 44% !important;
    }
    .installments-card table thead th:nth-child(2),
    .installments-card table tr.parent-row td:nth-child(2),
    .installments-card table thead th:nth-child(3),
    .installments-card table tr.parent-row td:nth-child(3),
    .installments-card table thead th:nth-child(4),
    .installments-card table tr.parent-row td:nth-child(4) {
      width: 18.6% !important;
    }
    /* Control inner sub-table layout and widths */
    .installments-card td[colSpan="4"] > div {
      padding: 8px 4px !important;
    }
    .installments-card table table th:nth-child(1),
    .installments-card table table td:nth-child(1) {
      width: 44% !important;
    }
    .installments-card table table th:nth-child(2),
    .installments-card table table td:nth-child(2),
    .installments-card table table th:nth-child(3),
    .installments-card table table td:nth-child(3) {
      width: 28% !important;
    }
    /* Checkbox and toggle button sizing */
    .fee-collection-wrapper input[type="checkbox"] {
      width: 14px !important;
      height: 14px !important;
    }
    .fee-collection-wrapper button:not(.header-buttons-container button):not(.bottom-buttons-container button):not(.fee-summary-buttons-container button) {
      width: 24px !important;
      height: 24px !important;
      font-size: 10px !important;
    }
    .fee-summary-buttons-container {
      display: flex !important;
      flex-direction: row !important;
      gap: 8px !important;
      width: 100% !important;
    }
    .fee-summary-buttons-container button {
      flex: 1 !important;
      padding: 8px 4px !important;
      font-size: 11px !important;
      white-space: nowrap !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
  }
`}
</style>

        <Container fluid className="py-4 fee-collection-wrapper">
          {/* Header Section */}
          <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "25px",
    flexWrap: "wrap",
    gap: "15px",
  }}
>
  {/* Left Group: Back Button + Heading */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "15px",
    }}
  >
    <div
      onClick={() => navigate(-1)}
      style={{
        background: "#fff",
        border: "1px solid #e2e8f0",
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "#475569",
        boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
      }}
    >
      <FaArrowLeft />
    </div>
    <h2
      style={{
        margin: 0,
        fontSize: "24px",
        fontWeight: "700",
        color: "#1e293b",
      }}
    >
      Fee Installments
    </h2>
  </div>

  {/* Right Group: Action Button */}
  <Button
    variant="primary"
    className="d-flex align-items-center justify-content-center"
    onClick={handleFeeAccuracyNavigation}
    style={{ fontSize: "14px", padding: "10px 12px" }}
  >
    <FaDownload className="me-2" size={14} />
    Fee Accuracy Report
  </Button>
</div>

          <Card className="border-0 shadow-sm rounded-4 mb-4">
            <Card.Body className="p-4">
              <div className="d-flex flex-column flex-lg-row align-items-center gap-4">
                <div className="w-100">
                  <h5 className="text-muted mb-3">Summary</h5>
                  <Row className="g-3">
                    {summaryCardsData.map((card, index) => {
                      const Icon = card.icon;
                      return (
                        <Col xs={6} lg={6} key={card.title + index}>
                          <div
                            className="h-100 rounded-4 p-3 border"
                            style={{ backgroundColor: card.bg, borderColor: card.border }}
                          >
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <div className="text-muted fw-semibold" style={{ fontSize: '14px' }}>
                                {card.title}
                              </div>

                              <div
                                className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                                style={{ width: 32, height: 32 }}
                              >
                                <Icon size={16} className="text-primary" />
                              </div>
                            </div>

                            {/* <div className="fw-bold text-dark fs-4">
                              {formatCurrency(card.value)}
                            </div> */}
                            <div className="fw-bold text-dark fs-4">
          {loading ? (
            <Spinner animation="border" size="sm" variant="secondary" />
          ) : (
            formatCurrency(card.value || 0)
          )}
        </div>
                          </div>

                        </Col>
                      );
                    })}
                  </Row>
                </div>

                <div className="text-center">
                  <div className="position-relative mx-auto" style={{ width: 180, height: 180 }}>
                    <div
                      className="w-100 h-100 rounded-circle"
                      style={{
                        background: `conic-gradient(#0d5adf ${paidPercent}%, #e9edff ${paidPercent}% 100%)`
                      }}
                    />
                    <div
                      className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle d-flex flex-column align-items-center justify-content-center"
                      style={{ width: 130, height: 130, boxShadow: '0 10px 20px rgba(13,90,223,0.1)' }}
                    >
                      <span className="fw-bold text-primary" style={{fontSize:'20px'}}>{formatCurrency(summaryMetrics2.totalPaid)}</span>
                      <small className="text-muted">Paid Fee*</small>
                    </div>
                  </div>
                  <p className="text-muted small mt-3 mb-3">
                    Track your fee status and make secure payments below
                  </p>
                   <div className="d-flex flex-row gap-2 fee-summary-buttons-container">
                    
                    <Button
                      variant="outline-primary"
                      className="flex-fill d-flex align-items-center justify-content-center"
                      onClick={handleFeeReceiptNavigation}
                      style={{ fontSize: "14px", padding: "10px 12px" }}
                    >
                      <FaDownload className="me-2" size={14} />
                      Fee Receipt
                    </Button>
                    <Button
                      variant="primary"
                      className="flex-fill d-flex align-items-center justify-content-center"
                      onClick={handleShowPaymentSection}
                      style={{ fontSize: "14px", padding: "10px 12px" }}
                    >
                      <FaCreditCard className="me-2" size={14} />
                      Pay Fees
                    </Button>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>


          {!feeCycleId && (
            <Alert variant="warning" className="mb-4">
              <FaExclamationTriangle className="me-2" />
              No fee cycle ID found. Please contact administration.
            </Alert>
          )}



          {showPaymentSection && (
            <div id="payment-section">
              {renderStudentDetails()}

              {/* Fee Installments Section */}
              <div
                className="installments-card"
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "25px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                  marginBottom: "25px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                  }}
                >
                  <h4
                    style={{
                      fontWeight: "700",
                      margin: 0,
                    }}
                  >
                    Fee Installments
                  </h4>
                </div>

                <div className="table-responsive">
                  <table className="table align-middle">
                    <thead>
                      <tr
                        style={{
                          background: "#f7f9fc",
                        }}
                      >
                        <th>Installment</th>
                        <th>Total Due</th>
                        <th>Total Paid</th>
                        <th>Balance</th>
                      </tr>
                    </thead>

                    <tbody>
                      {availableInstallments
                        .sort((a, b) => a.installmentNumber - b.installmentNumber)
                        .map((installment) => {
                          const metrics = getInstallmentMetrics(installment);
                          const totalInstallmentAmount = metrics.total;
                          const paidAmount = metrics.paid;
                          const payableAmount = metrics.balance;

                          const isSelected = selectedInstallments.some(
                            (item) => item.id === installment.id
                          );
                          const isFullyPaid = isInstallmentFullyPaid(installment);

                          return (
                            <React.Fragment key={installment.id}>
                              <tr
                                className="parent-row"
                                style={{
                                  borderBottom: "1px solid #f0f0f0",
                                }}
                              >
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "12px",
                                    }}
                                  >
                                    {!isFullyPaid && payableAmount > 0 ? (
                                      <input
                                        type="checkbox"
                                        style={{
                                          width: "18px",
                                          height: "18px",
                                          cursor: "pointer",
                                        }}
                                        checked={isSelected}
                                        onChange={() => handleInstallmentSelect(installment)}
                                      />
                                    ) : (
                                      <span
                                        style={{
                                          width: "18px",
                                          height: "18px",
                                          borderRadius: "50%",
                                          background: "#198754",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          color: "#fff",
                                          fontSize: "11px",
                                          fontWeight: "bold",
                                        }}
                                        title="Paid"
                                      >
                                        ✓
                                      </span>
                                    )}

                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <span
                                          style={{
                                            fontWeight: "600",
                                          }}
                                        >
                                          {installment.label}
                                        </span>
                                        <button
                                          className="mobile-icon"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleInstallmentClick(installment);
                                            toggleExpand(installment.id);
                                          }}
                                          style={{
                                            border: "none",
                                            background: "#eef4ff",
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            cursor: "pointer",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                            lineHeight: 1,
                                            padding: 0
                                          }}
                                        >
                                          {expandedItems[installment.id] ? "−" : "+"}
                                        </button>
                                      </div>
                                      {metrics.due_date && (
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#dc3545",
                                            fontWeight: "500",
                                            marginTop: "2px",
                                          }}
                                        >
                                          Due Date: {moment(metrics.due_date).format("DD MMM YYYY")}
                                        </span>
                                      )}
                                    </div>

                                    <button
                                      className="desktop-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleInstallmentClick(installment);
                                        toggleExpand(installment.id);
                                      }}
                                      style={{
                                        border: "none",
                                        background: "#eef4ff",
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {expandedItems[installment.id] ? <FaChevronUp /> : <FaChevronDown />}
                                    </button>
                                  </div>
                                </td>

                                <td
                                  style={{
                                    fontWeight: "600",
                                    color: "#2b303a",
                                  }}
                                >
                                  {formatCurrency(totalInstallmentAmount)}
                                </td>
                                <td
                                  style={{
                                    fontWeight: "600",
                                    color: "#198754",
                                  }}
                                >
                                  {formatCurrency(paidAmount)}
                                </td>
                                <td
                                  style={{
                                    fontWeight: "600",
                                    color: payableAmount > 0 ? "#b45309" : "#198754",
                                  }}
                                >
                                  {formatCurrency(payableAmount)}
                                </td>
                              </tr>

                              {expandedItems[installment.id] && (
                                <tr>
                                  <td colSpan={4}>
                                    <div
                                      style={{
                                        background: "#f8fafc",
                                        borderRadius: "12px",
                                        padding: "15px",
                                      }}
                                    >
                                      <InstallmentFeeBreakdown
                                        installment={installment}
                                        data={allInstallmentsData[installment.id]}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                    </tbody>
                  </table>
                </div>

                {/* Selected Installments Pay Now Section */}
                {selectedInstallments.length > 0 && (
                  <div
                    className="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-3 pt-3 border-top mt-3 bottom-buttons-container"
                  >
                    <div className="d-flex justify-content-between align-items-center w-100 w-md-auto">
                      <span className="text-muted me-2">Selected ({selectedInstallments.length}):</span>
                      <strong className="text-success fs-4 fw-bold">
                        {formatCurrency(calculateTotalSelectedAmount())}
                      </strong>
                    </div>

                    <Button
                      variant="primary"
                      size="lg"
                      className="w-100 w-md-auto"
                      style={{
                        background: "#198754",
                        color: "#fff",
                        border: "none",
                        padding: "12px 30px",
                        borderRadius: "10px",
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                      onClick={() => handlePayNow()}
                      disabled={paying || calculateTotalSelectedAmount() === 0}
                    >
                      {paying ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Processing...
                        </>
                      ) : (
                        <>
                          <FaCreditCard className="me-2" />
                          <span className="d-none d-md-inline">Pay Total Now ({formatCurrency(calculateTotalSelectedAmount())})</span>
                          <span className="d-inline d-md-none">Pay Now</span>
                        </>
                      )}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )}
        </Container>
      </div>
    </div>
  );
};



export default FeeCollection;
